import React, { useState } from 'react';
import { Box } from "@mui/material";
import ServerDetailsBasicTab from './ServerDetailsBasicTab';
import ServerDetailsAdvancedTab from './ServerDetailsAdvancedTab';
import ServerTabs from './components/ServerTabs';
import useBettingData from './hooks/useBettingData';
import {
  getGraphanaLink,
  getMarketType,
  getSiteCode,
  getLobbies
} from './utils/serverUtils';

const ServerDetailsComponent = ({ serverDetails }) => {
  const [tabToggle, setTabToggle] = useState(1);
  const activeLast7Days = useBettingData(serverDetails);

  const renderTabContent = () => {
    switch (tabToggle) {
      case 1:
        return (
          <ServerDetailsBasicTab
            serverDetails={serverDetails}
            getGraphanaLink={() => getGraphanaLink(serverDetails)}
            getMarketType={getMarketType}
            getSiteCode={getSiteCode}
            getLobbies={() => getLobbies(serverDetails)}
            activeLast7Days={activeLast7Days}
          />
        );
      case 2:
        return <ServerDetailsAdvancedTab />;
      default:
        return null;
    }
  };

  return (
    <Box className="server-details-container">
      <ServerTabs
        activeTab={tabToggle}
        onTabChange={setTabToggle}
      />
      <Box className="content-section">
        {renderTabContent()}
      </Box>
    </Box>
  );
};

export default ServerDetailsComponent;